
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bridge",
      function () {
        return require("private-next-pages/bridge.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bridge"])
      });
    }
  